import {
  type HotelShoppedProductTrackingProperties,
  createTrackingEmitterHooks,
} from "@b2bportal/core-tracking";
import type { CheckoutTrackingProperties } from "../types";

export type HotelsCheckoutTrackingAttributes = CheckoutTrackingProperties & {
  hotelCheckoutShoppedProduct: HotelShoppedProductTrackingProperties;
  checkoutCartId: string;
  quoteEncryptedTrackingProperties?: string[];
};
export type HotelCheckoutPurchaseCompletedRawEvent = {
  name: HotelsCheckoutRawEventName.HotelCheckoutPurchaseCompleted;
  properties: {
    booking_id: string;
  };
};

export type HotelCheckoutPurchaseFailedRawEvent = {
  name: HotelsCheckoutRawEventName.HotelCheckoutPurchaseFailed;
};

export enum HotelsCheckoutRawEventName {
  HotelCheckoutPurchaseCompleted = "HotelCheckoutPurchaseCompleted",
  HotelCheckoutPurchaseFailed = "HotelCheckoutPurchaseFailed",
}

export type HotelsCheckoutRawEvent =
  | HotelCheckoutPurchaseCompletedRawEvent
  | HotelCheckoutPurchaseFailedRawEvent;

export const {
  useEmitRawEvent: useEmitCoreHotelsCheckoutRawEvent,
  useEmitRawEventOnce: useEmitCoreHotelsCheckoutRawEventOnce,
  useEmitBeforeLoad: useEmitCoreHotelsCheckoutBeforeLoad,
} = createTrackingEmitterHooks<HotelsCheckoutRawEvent>();
